import {BackendApi} from '@/services/backend_api'

export default {
  get (id) {
    return BackendApi.getClient().get(`partners/${id}`)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  cget () {
    return BackendApi.getClient().get('partners/')
      .then(response => { return response })
      .catch(e => { throw e })
  },
  post (partner) {
    return BackendApi.getClient().post('partners/', partner)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  put (partner) {
    return BackendApi.getClient().put(`partners/${partner.id}`, partner)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  delete (id) {
    return BackendApi.getClient().delete(`partners/${id}`)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  recoverPassword (id) {
    return BackendApi.getClient().put(`users/partner-password-recovery/${id}`)
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/partner.js